import styled from 'styled-components';
// Shared Components
import { CardContentDetailList, CardHeader, CardImage } from '../BaseCard/BaseCard';
import { CardContentWrapper, CardWrapper, EmptyCardImage } from '../style';
import SocialSubscribing, {
  SocialSubscribingProps,
} from '@components/SocialMediaLinks/SocialSubscribing';
import ConditionallyWrapWithUrl from '@components/MiscComponents/ConditionallyWrapWithUrl';
import { getPhoneFormattedText, getPhoneURI } from '@util/phoneNumber';
import { FC } from 'react';
import { useTranslations } from 'next-intl';

interface Office {
  name: string;
  url: string; // this should be just a string ~awt
}

export interface AdvisorCardProps {
  image?: string;
  alt_text?: string;
  name?: string;
  title?: string;
  phone?: string;
  licenseNumber?: string;
  office?: Office;
  urlFacebook?: string;
  urlTwitter?: string;
  urlLinkedin?: string;
  urlInstagram?: string;
  urlYoutube?: string;
  urlTiktok?: string;
  imageAspectRatio?: number;
  urlAdvisor?: string;
  urlAdvisorBio?: string;
  className?: string;
}

//Social Media Icons and links
const MappedSocialSubscribing = ({ socialMedias }) => {
  const props: SocialSubscribingProps = {
    socialMedias: socialMedias,
  };
  return <SocialSubscribing {...props} />;
};

const AdvisorCard: FC<AdvisorCardProps> = ({
  image,
  alt_text = 'Advisor',
  name,
  title,
  phone,
  licenseNumber,
  office,
  urlFacebook,
  urlTwitter,
  urlLinkedin,
  urlInstagram,
  urlTiktok,
  urlYoutube,
  imageAspectRatio = 0.75,
  urlAdvisor,
  className,
}) => {
  const t = useTranslations();
  //prepare social media links for mapping
  // if url is null or undefined, remove it from the array
  const socialMediaLinks = [
    { platform: 'instagram', url: urlInstagram },
    { platform: 'twitter', url: urlTwitter },
    { platform: 'facebook', url: urlFacebook },
    { platform: 'linkedin', url: urlLinkedin },
    { platform: 'youtube', url: urlYoutube },
    { platform: 'tiktok', url: urlTiktok },
  ].filter((socialMedia) => socialMedia.url);

  return (
    <CardWrapper className={className}>
      {image ? (
        <CardImage
          data-testid="advisor-photo"
          image={image}
          alt_text={alt_text}
          imageAspectRatio={imageAspectRatio}
          url={urlAdvisor}
          type="advisor"
        />
      ) : (
        <EmptyCardImage />
      )}

      {name && <CardHeader header={name} subHeader={title} url={urlAdvisor} />}

      <CardContentWrapper>
        <CardContentDetailList>
          {phone && (
            <li>
              {t('Phone')}:{' '}
              <a data-testid="advisor-phone" className="phone-link" href={getPhoneURI(phone)}>
                {getPhoneFormattedText(phone)}
              </a>
            </li>
          )}
          {licenseNumber && <li data-testid="advisor-license-number">{licenseNumber}</li>}
          {office?.name && (
            <li data-testid="advisor-office">
              {t('Shop')}:{' '}
              <ConditionallyWrapWithUrl href={office.url}>{office.name}</ConditionallyWrapWithUrl>
            </li>
          )}
        </CardContentDetailList>

        {socialMediaLinks.length > 0 && (
          <WrapperSocials data-testid="advisor-socials">
            <MappedSocialSubscribing socialMedias={socialMediaLinks} />
          </WrapperSocials>
        )}
      </CardContentWrapper>
    </CardWrapper>
  );
};

export default AdvisorCard;

const WrapperSocials = styled.div`
  a + a {
    margin-left: 16px;
  }
`;

// For use in Story
export const StoryWrapper = styled.div`
  display: flex;
`;
